<div class="contact-form-area-one">

    <app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

    <div class="rts-title-area contact" [ngClass]='alignment'>
        <p class="pre-title">
            {{"MENU.CONTACT"| translate}}
        </p>
        <h2 class="title">{{"CONTACT.DESC2"| translate}}</h2>
    </div>
    <div id="form-messages"></div>
    <form id="contact-form" method="post" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="name-email gap-3">
            <div class="form-group">
                <input type="text" formControlName="firstName" [placeholder]="'CONTACT.FIRSTNAME' | translate"
                    name="firstName" class="form-control" />

                <div class="text-danger mt-1" *ngIf="f['firstName'].touched && f['firstName'].invalid">
                    <div *ngIf="f['firstName'].errors?.['required']">
                        {{"CONTACT.FIRSTNAMEREQUIRED" | translate}}
                    </div>
                    <div *ngIf="f['firstName'].errors?.['minlength']">
                        {{"CONTACT.FIRSTNAMEVALIDATION" | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group">
                <input type="text" formControlName="lastName" [placeholder]="'CONTACT.LASTNAME' | translate"
                    name="lastName">
                <div class="text-danger mt-1" *ngIf="f['lastName'].touched && f['lastName'].invalid">
                    <div *ngIf="f['lastName'].errors?.['required']">
                        {{"CONTACT.LASTNAMEREQUIRED" | translate}}
                    </div>
                    <div *ngIf="f['lastName'].errors?.['minlength']">
                        {{"CONTACT.LASTNAMEVALIDATION" | translate}}
                    </div>
                </div>
            </div>
        </div>

        <div class="name-email gap-3">
            <div class="form-group">
                <input type="email" formControlName="email" [placeholder]="'CONTACT.EMAIL' | translate" name="email">
                <div class="text-danger" *ngIf="f['email'].touched && f['email'].invalid">
                    <div *ngIf="f['email'].errors?.['required']"> {{"CONTACT.EMAILREQUIRED" |
                        translate}}</div>
                    <div *ngIf="f['email'].errors?.['pattern']">{{"CONTACT.EMAILVALIDATION" |
                        translate}}</div>
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="phone-number" formControlName="mobile" [placeholder]="'REGISTER.PHONENUMBER' | translate"
                    name="mobile">
                <div class="text-danger" *ngIf="f['mobile'].touched && f['mobile'].invalid">
                    <div *ngIf="f['mobile'].errors?.['required']">{{"CONTACT.MOBILErEQUIRED" |
                        translate}}</div>
                    <div *ngIf="f['mobile'].touched && f['mobile'].errors?.['invalidPhoneCode']">
                        {{"PROFILE.PHONE_VALIDATION" |
                        translate}}</div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <textarea formControlName="content" [placeholder]="'CONTACT.MESSAGE' | translate" name="content"
                class="mb-4"></textarea>
            <div class="text-danger" *ngIf="f['content'].touched && f['content'].invalid">
                <div *ngIf="f['content'].errors?.['required']">{{"CONTACT.MESSAGErEQUIRED" | translate}}
                </div>
                <div *ngIf="f['content'].errors?.['minlength']">{{"CONTACT.MESSAGEVALIDATION" |
                    translate}}
                </div>
            </div>
        </div>
        <button type="submit" class="rts-btn btn-primary" [ngClass]='buttonAlign'>{{"COMMON.SEND"| translate}}</button>
    </form>
</div>